import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { VALUES } from "../data/partners";
import { useLang } from "../i18n";

// "People before profit" — values band.
export const ValuesSection = ({ index = "" }) => {
  const { t } = useLang();
  const v = t.values;

  return (
    <section className="relative overflow-hidden border-y border-[#0A3E63]/40 bg-[#0E1B24] py-20 sm:py-28" data-testid="values-section">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(#FFFFFF 1px, transparent 1px)", backgroundSize: "26px 26px" }} />
      <div className="relative mx-auto max-w-[1760px] px-5 sm:px-8">
        <Reveal>
          <p className="font-mono2 text-[11px] uppercase tracking-[0.28em] text-[#7FB2D4]">{index && <span className="text-[#6B8798]">{index} // </span>}{v.label}</p>
          <h2 className="font-display mt-5 max-w-3xl text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="values-slogan">
            {v.slogan}
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B9C6CE]">{v.lead}</p>
        </Reveal>

        <div className="mt-14 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
          {VALUES.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Circle;
            const copy = v.items[item.id] || item;
            return (
              <Reveal key={item.id} delay={i * 0.08} className="group flex flex-col bg-[#0E1B24] p-7 transition-colors duration-500 hover:bg-[#122433]" data-testid={`value-card-${item.id}`}>
                <Icon size={24} className="text-[#7FB2D4] transition-transform duration-500 group-hover:-translate-y-0.5" />
                <h3 className="font-display mt-5 text-sm font-extrabold uppercase tracking-[0.1em] text-white">{copy.title}</h3>
                <p className="mt-3 text-[13px] leading-relaxed text-[#B9C6CE]">{copy.text}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
